import { BASE_API_URL } from '@env';
import { useMutation, useQueryClient } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import axios from 'axios';

interface TransferBookingRequest {
  user_id: string;
  email: string;
  target_event_id: string;
}

interface TransferBookingResponse {
  success: boolean;
  message: string;
}

export const useTransferBooking = () => {
  const queryClient = useQueryClient();

  return useMutation<TransferBookingResponse, Error, { eventId: string; transferData: TransferBookingRequest }>(
    async ({ eventId, transferData }) => {
      const token = useUserStore.getState().token;
      
      if (!token) {
        throw new Error('No authentication token available');
      }

      console.log('🔍 useTransferBooking: Making API call with token:', token ? 'EXISTS' : 'MISSING');
      console.log('🔍 useTransferBooking: API URL:', `${BASE_API_URL}events/${eventId}/pyxi-select/transfer-user`);
      console.log('🔍 useTransferBooking: Transfer data:', transferData);

      const config = {
        headers: { 
          Authorization: token, 
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
      };

      try {
        const response = await axios.post(`${BASE_API_URL}events/${eventId}/pyxi-select/transfer-user`, transferData, config);
        console.log('🔍 useTransferBooking: API Response:', response.data);
        return response.data;
      } catch (error) {
        console.error('🔍 useTransferBooking: API Error:', error);
        if (axios.isAxiosError(error)) {
          const errorMessage = error.response?.data?.message || error.message;
          throw new Error(`Failed to transfer booking: ${error.response?.status} - ${errorMessage}`);
        }
        throw new Error('Failed to transfer booking');
      }
    },
    {
      onSuccess: () => {
        // Refetch relevant queries after successful transfer
        queryClient.refetchQueries(['_getPyxiSelectEvents']);
        queryClient.refetchQueries(['orderById']);
        queryClient.refetchQueries(['eventById']);
      },
    }
  );
};
